<span
  class="status-indicator"
  [class.status-indicator--approved]="status === 'approved'"
  [class.status-indicator--declined]="status === 'declined'"
  [class.status-indicator--eligible]="status === 'eligible'"
  [class.status-indicator--not-determined]="status === 'not-determined'"
  [class.status-indicator--pending]="status === 'pending'"
  [class.status-indicator--sm]="size === 'sm'"
  [class.status-indicator--md]="size === 'md'"
  [class.status-indicator--lg]="size === 'lg'"
>
  <i *ngIf="showIcon" class="status-indicator__icon" [ngClass]="statusIcon"></i>
  <span class="status-indicator__text">{{ statusText }}</span>
</span>
